import React, { useState } from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import client from '../../api/client';

const PARTS = [
  ['address_line1', 'Street', 'Street address', 'col-span-6'],
  ['address_line2', 'Apt / unit', 'Apt / unit (optional)', 'col-span-6'],
  ['city', 'City', 'City', 'col-span-3'],
  ['state', 'State', 'State', 'col-span-1 min-w-[3.5rem]'],
  ['postal_code', 'ZIP', 'ZIP / postal', 'col-span-2'],
];

// Lob-ready mailing address (street / city / state / ZIP), saved on blur.
export const AddressFields = ({ guest, onSaved }) => {
  const [f, setF] = useState(() => Object.fromEntries(PARTS.map(([k]) => [k, guest[k] || ''])));
  const [status, setStatus] = useState(guest.address_status);
  const [saved, setSaved] = useState(f);

  const save = async () => {
    if (PARTS.every(([k]) => f[k] === saved[k])) return;
    try {
      const { data } = await client.put(`/guests/${guest.id}`, f);
      const next = Object.fromEntries(PARTS.map(([k]) => [k, data[k] || '']));
      setF(next); setSaved(next);
      setStatus(data.address_status);
      onSaved({ ...f, address: data.address, address_status: data.address_status });
    } catch { /* surfaced by next load */ }
  };

  return (
    <div data-testid={`guest-address-fields-${guest.id}`} className="space-y-1.5">
      <div className="grid grid-cols-6 gap-1.5">
        {PARTS.map(([k, label, ph, span]) => (
          <input key={k} data-testid={`guest-${k}-${guest.id}`} aria-label={label} value={f[k]} placeholder={ph}
                 onChange={(e) => setF({ ...f, [k]: e.target.value })} onBlur={save}
                 className={`${span} px-2 py-1 rounded border border-[#EFE3D8] bg-white text-xs`} />
        ))}
      </div>
      {status === 'needs_fix' && (
        <p data-testid={`guest-address-needs-fix-${guest.id}`} className="text-[11px] text-[#A15A2A] inline-flex items-center gap-1"><AlertTriangle className="w-3 h-3" /> Needs fixing before mailing: add street, city, state and ZIP.</p>
      )}
      {status === 'missing' && (
        <p className="text-[11px] text-[#9A8A7E]">No mailing address yet. Add one to send printed postcards.</p>
      )}
      {status === 'ok' && (
        <p className="text-[11px] text-[#2F5D2F] inline-flex items-center gap-1"><CheckCircle2 className="w-3 h-3" /> Ready for postcards</p>
      )}
    </div>
  );
};

export default AddressFields;
